import { render, staticRenderFns } from "./CardFrecuentQuestions.vue?vue&type=template&id=773ff349&"
import script from "./CardFrecuentQuestions.vue?vue&type=script&lang=js&"
export * from "./CardFrecuentQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports